import configApi from '@/api/sys/config'
import qs from 'qs'
const sys = {
	state: {
		title : '',
		version:'',
		login:'',
		company:'',
		logo:'',
		initConfig:false,
		pageSize:20,//列表的默认页容量
		tableMaxHeight:420,//列表的默认页容量
	},
	getters: {
	},
	mutations: {
		SET_INITCONFIG( state, initConfig ) {
			state.initConfig = initConfig
		},
		SET_VERSION( state, version) {
			state.version = version
		},
		SET_LOGIN( state, login) {
			state.login = login
		},
		SET_TITLE( state, title) {
			state.title = title
		},
		SET_COMPANY( state, company) {
			state.company = company
		},
		SET_LOGO( state, logo) {
			state.logo = logo
		}
	},
	actions: {
		initSysConfig({ state,commit }, path) {
			return new Promise(( resolve, reject )=>{
				if(!state.initConfig){
					const query = qs.parse(location.search.substring(1))
					let v = query.v
					configApi.getValues({v:v}).then(res=>{
						commit('SET_INITCONFIG',true)
						commit('SET_VERSION','1.0')
						commit('SET_LOGIN',true)
						commit('SET_TITLE',res.data.data.title)
						commit('SET_COMPANY',res.data.data.copyright)
						commit('SET_LOGO',res.data.data.logo)
						resolve()
					})
				}else{
					resolve()
				}
			})
			
		}
	}
}
export default sys
